<template>
  <div class="page not-found">
    <PageHeader title="Pagina nu există" subtitle="Adresa a fost scrisă greșit sau pagina a fost mutată." icon="mdi-map-marker-question-outline" />
    <div class="page-body">
      <section class="panel not-found__panel">
        <p>Mergeți la pagina principală și alegeți din meniul din stânga.</p>
        <v-btn class="btn-green" large to="/">Pagina principală</v-btn>
      </section>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/layout/PageHeader.vue";

export default {
  name: "NotFound",
  components: { PageHeader },
};
</script>

<style scoped>
.not-found__panel {
  padding: 28px 24px;
  max-width: 640px;
}
.not-found__panel p {
  color: var(--ink-2);
  margin-bottom: 18px;
}
</style>
